/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import {
	VIEW_KIND_BOARD,
	VIEW_KIND_MATRIX,
	VIEW_KIND_SECTION,
	VIEW_KIND_TABLE,
	VIEW_KIND_TIMELINE,
	VIEW_KIND_TREE,
} from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import BoardIcon from '@atlaskit/icon/core/board';
import ChartBubbleIcon from '@atlaskit/icon/core/chart-bubble';
import FolderOpenIcon from '@atlaskit/icon/core/folder-open';
import BulletedListIcon from '@atlaskit/icon/core/list-bulleted';
import DepartmentIcon from '@atlaskit/icon/core/department';
import TimelineIcon from '@atlaskit/icon/core/timeline';
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import { token } from '@atlaskit/tokens';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import { fg } from '@atlassian/jira-feature-gating';

type ViewItemIconProps = NewCoreIconProps & {
	isSelected?: boolean;
	viewKind?: ViewKind;
	locked?: boolean;
};

export const ViewItemIcon = ({
	isSelected,
	viewKind,
	locked,
	...rest
}: ViewItemIconProps): React.JSX.Element | null => {
	const color = isSelected ? token('color.icon.selected') : token('color.icon.subtle');

	if (fg('jpd_tree-view')) {
		if (locked) {
			return <LockLockedIcon color={color} {...rest} />;
		}
	}

	switch (viewKind) {
		case VIEW_KIND_TABLE:
			return <BulletedListIcon color={color} {...rest} />;
		case VIEW_KIND_BOARD:
			return <BoardIcon color={color} {...rest} />;
		case VIEW_KIND_MATRIX:
			return <ChartBubbleIcon color={color} {...rest} />;
		case VIEW_KIND_TIMELINE:
			return <TimelineIcon color={color} {...rest} />;
		case VIEW_KIND_TREE:
			if (fg('jpd_tree-view')) {
				return <DepartmentIcon color={color} {...rest} />;
			}

			return <BulletedListIcon color={color} {...rest} />;
		case VIEW_KIND_SECTION:
			return <FolderOpenIcon color={color} {...rest} />;
		default:
			return null;
	}
};
